export const convertStringToNumber = (obj) => {
    return Object.fromEntries(
        Object.entries(obj).map((val) => {
          if (!isNaN(val[1] * 1)) {
            val[1] = parseInt(val[1]).toFixed() * 1;
          }
          return val;
        })
      );
}